import Drawer from '@/components/Drawer';
import { CloseFilledIcon, JenLogoIcon, MenuIcon } from '@/components/Icons';
import SideBar from '@/components/SideBar';
import { useDimensions } from '@/hooks/useDimensions';
import { useLeftPanelDrawer } from '@/state/drawer-store';
import { useLinksDetailShow } from '@/state/show-store';

interface NavBarProps {
  children: React.ReactNode;
}

export default function NavBar({ children }: NavBarProps) {
  const { setIsDrawerShow } = useLeftPanelDrawer();

  const { setIsShow: setLinkDetailShow } = useLinksDetailShow();

  return (
    <>
      <div className="w-full h-full">
        <div className={`grid w-full h-full gap-[1px] grid-cols-1 grid-rows-[52px_minmax(0,1fr)_96px]`}>
          <div className="flex border-b border-jen-border">
            <div
              onClick={() => setIsDrawerShow(true)}
              className="border-r border-jen-border flex-1 flex items-center text-jen-content-secondary text-[14px]"
            >
              <JenLogoIcon className="mx-4" />
            </div>
            <div className="w-[52px] h-[52px] flex justify-center items-center">
              <div
                className="flex justify-center items-center"
                onClick={() => {
                  setLinkDetailShow(true);
                }}
              >
                <MenuIcon fillColor="#67666d" className="text-jen-grey-3 cursor-pointer" />
              </div>
            </div>
          </div>
          <div className="bg-white lg:row-span-1 relative z-[1] ">{children}</div>
        </div>
      </div>
      <LinkDetailDrawer />
    </>
  );
}

const LinkDetailDrawer = () => {
  const { isShow: isLinksDetailShow, setIsShow: setIsDrawerShow } = useLinksDetailShow();
  const { isMobileOrPad } = useDimensions();
  if (!isMobileOrPad) {
    return null;
  }
  return (
    <Drawer className="bg-white" side="right" width="100vw" isOpen={isLinksDetailShow} onClose={() => setIsDrawerShow(false)}>
      <div className="w-full h-full flex flex-col relative">
        <CloseFilledIcon onClick={() => setIsDrawerShow(false)} className=" absolute right-2 top-2 box-content p-[14px]" />
        <div className="w-full h-full  bg-jen-background-primary">
          <SideBar clickNavigationCallback={() => setIsDrawerShow(false)} />
        </div>
      </div>
    </Drawer>
  );
};
